import React from 'react';
import { AuthContext } from "../../AuthContext";

const UserNameData = (props) => {
    const authContext = React.useContext(AuthContext);

    const capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return (
        <div>
            <h5 className="d-flex justify-content-center" style={{ color: "#6d9baf", fontWeight: "bold", fontSize: "18px", marginBottom:"0px"}}>Welcome : {capitalize( authContext.data.firstName) + " " + capitalize(authContext.data.lastName)}</h5>
        </div>
        )
}

export { UserNameData };